module.exports = __webpack_public_path__ + "static/img/1-5.df350a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/1-5.jpg
// module id = oSMR
// module chunks = 1